/**
 * App Language Provider
 * Add more locales here
 */
// import { addLocaleData } from 'react-intl';
import enLang from './entries/en-US';
import thLang from './entries/th-TH';


const AppLocale = {
    en: enLang,
    th: thLang,
};

// addLocaleData(AppLocale.en.data);
// addLocaleData(AppLocale.th.data);


export default AppLocale;
